
export const theme = {
    colors: {
      primary: '#000000',
      secondary: '#666666',
      tertiary: '#333333',
      background: '#FFFFFF',
      text: '#000000',
      textLight: '#666666',
    },
    fonts: {
      primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    },
    breakpoints: {
      mobile: '320px',
      tablet: '768px',
      desktop: '1024px',
      wide: '1300px'
    },
    spacing: {
      xs: '0.25rem',
      sm: '0.5rem',
      md: '1rem',
      lg: '2rem',
      xl: '4rem'
    },
    transitions: {
      fast: '0.2s ease',
      normal: '0.3s ease',
      slow: '0.5s ease'
    },
    zIndex: {
      nav: 100,
      modal: 200,
      overlay: 300
    }
  };